module.exports = __webpack_public_path__ + "img/全省统一算力交易服务生态市场.04e9bb40.png";